import React from "react";
import PropTypes from 'prop-types';
import makeStyles from "@material-ui/core/styles/makeStyles";
import DefaultType from "../../../../../../Utils/Form/FormDynamic/Fields/DefaultType/DefaultType";
import TextType from "../../../../../../Utils/Form/FormDynamic/Fields/TextType";
import TypeEntity from "../../../../../../Utils/Form/FormDynamic/Fields/EntityExternal/Entity";
import SelectType from "../../../../../../Utils/Form/FormDynamic/Fields/SelectType/Select";
import CheckboxComponent from "../../../../../JsonScreen/Screen/ScreenComponents/CheckboxComponent";

const useStyles = makeStyles(() => ({
    generalInfoContainer: {
        padding: 10,
        height: '100%',
        overflow: 'auto'
    }
}));

const GeneralInformation = ({values, setValue}) => {
    const classes = useStyles();
    return (
        <div className={classes.generalInfoContainer}>
            <DefaultType
                values={values}
                field={{
                    type: 'string',
                    path: 'id',
                    label: "Entity Id",
                    autofocus: true
                }}
                setValue={setValue}
                labelStyles={{width: 100}}
                fieldStyles={{width: 250}}
            />
            <DefaultType
                values={values}
                field={{
                    type: 'string',
                    path: 'name',
                    label: "Name",
                    multiLanguage: true
                }}
                setValue={setValue}
                labelStyles={{width: 100}}
                fieldStyles={{width: 250}}
            />
            <TextType
                values={values}
                field={{
                    type: 'string',
                    path: 'description',
                    label: "Description"
                }}
                setValue={setValue}
                labelStyles={{width: 100}}
                fieldStyles={{width: 250}}
            />
            <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                <div>
                    <DefaultType
                        values={values}
                        field={{
                            type: 'string',
                            path: 'collection',
                            label: "Collection"
                        }}
                        setValue={setValue}
                        labelStyles={{width: 100}}
                        fieldStyles={{width: 250}}
                    />
                </div>
                <div>
                    <CheckboxComponent
                        screenName={'fakeScreen'}
                        globalValues={{
                            param: {
                                fakeScreen: values
                            }
                        }}
                        element={{
                            properties: {
                                path: 'sharedCollection',
                                label: "Is Shared"
                            },
                            styles: [{
                                size: 'small',
                                fontSize: '14px'
                            }]
                        }}
                        setValue={setValue}
                        doActions={() => {}}
                    />
                </div>
            </div>

            <TypeEntity
                values={values}
                field={{
                    type: 'entityExternal',
                    path: 'inherit',
                    label: "Inherit",
                    entity: "schema"
                }}
                setValue={setValue}
                labelStyles={{width: 100}}
                fieldStyles={{width: 250}}
            />
            <SelectType
                values={values}
                field={{
                    type: "bool",
                    path: 'auditable',
                    label: "Auditable"
                }}
                setValue={setValue}
                labelStyles={{width: 100}}
                fieldStyles={{width: 250}}
            />
            <TypeEntity
                values={values}
                field={{
                    type: 'entityExternal',
                    path: 'application',
                    label: "Application",
                    entity: "application",
                    isArray: true
                }}
                setValue={setValue}
                labelStyles={{width: 100}}
                fieldStyles={{width: 250}}
            />
        </div>
    )
};

export default GeneralInformation

GeneralInformation.propTypes = {
    values: PropTypes.object,
    setValue: PropTypes.func
};